import {
  OnRedirectionModalAppearance,
  OnRedirectionModalClickClose,
  OnRejectionModalAppearance,
  OnRejectionModalClickClose,
  OnRejectionModalClickOffers
} from './modals.types'

export const REDIRECTION_MODAL_APPEARANCE = 'REDIRECTION_MODAL_APPEARANCE'
export const REDIRECTION_MODAL_CLICK_CLOSE = 'REDIRECTION_MODAL_CLICK_CLOSE'
export const REJECTION_MODAL_APPEARANCE = 'REJECTION_MODAL_APPEARANCE'
export const REJECTION_MODAL_CLICK_CLOSE = 'REJECTION_MODAL_CLICK_CLOSE'
export const REJECTION_MODAL_CLICK_OFFERS = 'REJECTION_MODAL_CLICK_OFFERS'

export const onRedirectionModalAppearance: OnRedirectionModalAppearance = () => ({
  type: REDIRECTION_MODAL_APPEARANCE
})

export const onRedirectionModalClickClose: OnRedirectionModalClickClose = () => ({
  type: REDIRECTION_MODAL_CLICK_CLOSE
})

export const onRejectionModalAppearance: OnRejectionModalAppearance = () => ({
  type: REJECTION_MODAL_APPEARANCE
})

export const onRejectionModalClickClose: OnRejectionModalClickClose = () => ({
  type: REJECTION_MODAL_CLICK_CLOSE
})

export const onRejectionModalClickOffers: OnRejectionModalClickOffers = () => ({
  type: REJECTION_MODAL_CLICK_OFFERS
})
